export default "__VITE_ASSET__7vb4RtTN__"